module.exports = __webpack_public_path__ + "img/ios-phone-portrait.df7ab2eb.svg";